import React, { Component } from 'react';

class GlobalEatDrinkPostSkeleton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="eat-drink-post-items-grid">
        {
          Array.from(Array(6).keys()).map((i) => {
            return (
            <div key={i} className="item">
              <div className="item-image skeleton-shine">
              </div>
              <div className="item-content">
                <div className="item-taxonomy">
                  <span className="item-brand skeleton-shine"></span>
                  <span className="item-category skeleton-shine"></span>
                </div>
                <h3 className="item-title skeleton-shine"></h3>
                <div className="item-description skeleton-shine">
                </div>
                <div className="item-button skeleton-shine">
                </div>
              </div>
            </div>
            );
          })
        }
      </div>
    );
  }
}

export default GlobalEatDrinkPostSkeleton;



// WEBPACK FOOTER //
// ./scripts/components/GlobalEatDrinkPostSkeleton/GlobalEatDrinkPostSkeleton.js